import { atomWithStorage } from 'jotai/utils';

export const isFeatureFlagPanelOpenAtom = atomWithStorage<boolean>(
  'isFeatureFlagPanelOpen',
  false
);

export const showAiFeaturesAtom = atomWithStorage<boolean>(
  'showAiFeatures',
  false
);

// Feature flags surfaced in the (?featureFlags) dev panel. The transport-order flag was removed
// once the feature shipped permanently — add new flags here as `name: atom` pairs.
export const featureFlagAtoms: Record<string, unknown> = {
  aiFeatures: showAiFeaturesAtom,
};
